export const Film = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="4" width="24" height="24" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M4 16L28 16" stroke="currentColor" stroke-width="2"/>
<path d="M4 10L10 10" stroke="currentColor" stroke-width="2"/>
<path d="M22 10L28 10" stroke="currentColor" stroke-width="2"/>
<path d="M4 22L10 22" stroke="currentColor" stroke-width="2"/>
<path d="M22 22L28 22" stroke="currentColor" stroke-width="2"/>
<path d="M10 4L10 28" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22 4L22 28" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
